var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximizeCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 7.66659V4.33325M7.33325 4.33325H10.6666M7.33325 4.33325L11.4999 8.49992M20.6666 7.66659V4.33325M20.6666 4.33325H17.3333M20.6666 4.33325L16.4999 8.49992M7.33325 14.3333V17.6666M7.33325 17.6666H10.6666M7.33325 17.6666L11.4999 13.4999M20.6666 17.6666L16.4999 13.4999M20.6666 17.6666V14.3333M20.6666 17.6666H17.3333",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeCv);
export default __webpack_public_path__ + "static/media/maximizeCV.76b9524f4fa29c808303e54748bd0051.svg";
export { ForwardRef as ReactComponent };